// PointCountInput — ActivityWizard Steg 3 (delspår 3d). Antal poäng (→
// tournaments.points_per_match vid 3g). Renderas av Step3 ENDAST för tournament-typer
// (activity_type.tournament_format IS NOT NULL: americano/mexicano). Default 32.

import { NumberInput } from "@/components/ui/number-input";

interface PointCountInputProps {
  value: number | null;
  onValueChange: (value: number) => void;
}

export default function PointCountInput({ value, onValueChange }: PointCountInputProps) {
  return (
    <NumberInput
      data-testid="point-count"
      value={value}
      min={1}
      emptyValue={32}
      onValueChange={(v) => onValueChange(Math.max(1, Math.round(v) || 32))}
      className="w-24 rounded-xl"
    />
  );
}
